import { CreateDropLocation, DropLocation, Cell } from '@m4a3/api-client';
import { Notification } from '../../actions/uiActions';
import { Obstacle } from '../../models/obstacle.interface';

// Extended CreateDropLocation interface to include risk field
export interface CreateDropLocationRequest extends CreateDropLocation {
  risk?: 'HIGH' | 'LOW' | 'VERIFIED' | 'UNKNOWN';
}

// LiDAR point interface
export interface LidarPoint {
  height: number; // Original AMSL height
  intensity: number;
  lat: number;
  lng: number;
  metresFromPoint: number;
  heightAGL: number; // Height Above Ground Level (AGL)
  heightAMSL: number; // Original AMSL height for reference
  distanceFromPoint: number;
  x?: number;
  y?: number;
}

// Map position interface
export interface MapPosition {
  lat: number;
  lng: number;
}

// Map type options
export type MapType = 'manna' | 'satellite' | 'roadmap';

// Risk level enum
export type RiskLevel = 'HIGH' | 'LOW' | 'VERIFIED' | 'UNKNOWN';

// Loading states interface
export interface LoadingStates {
  lidarData: boolean;
  heightData: boolean;
  riskEvaluation: boolean;
  coordinateDropLocations: boolean;
  savingDropLocation: boolean;
  gettingLocation: boolean;
}

// Props interface for the main component
export interface MobileDropAnalyzerProps {
  notify: (notification: Notification) => void;
  getCells: () => void;
  cells: Cell[];
  selectedCellId: number;
  setSelectedCell: (cellId: number) => void;
  geofences: any;
  getGeofences: () => void;
  getObstacles: (cellId: number) => void;
}

// Constants
export const MAP_CONFIG = {
  DEFAULT_CENTER: [53.39292547693334, -6.395731067422041] as const,
  DEFAULT_ZOOM: 16,
  PIN_VISIBILITY_OFFSET: -0.0005, // 55m south for pin visibility
  ZOOM_LEVELS: {
    MIN: 8,
    MAX: 23,
    DETAIL: 17,
    USER_LOCATION: 17
  },
  TILE_URLS: {
    MANNA: 'https://tiles.manna.aero/{z}/{x}/{y}.png',
    SATELLITE: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    ROADMAP: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  }
} as const;

// API response types
export interface HeightDataResponse {
  height: number;
}

export interface ApiError {
  status?: number;
  message?: string;
  errorMessage?: string;
} 